import { CompanyWithSitesMinifiedRowType } from '@api';
import { Grid } from '@mantine/core';
import { useController, useFormContext } from 'react-hook-form';
import { CompanyLinkFormValuesType } from '../../../../types';
import { BUSINESS_FIELDS_GRID_COL_SPAN } from '../../constants';
import { SiteSelectCombobox } from './components';
import { useSiteCombobox } from './hooks';

type SiteSelectPropsType = {
  companySites: CompanyWithSitesMinifiedRowType[];
  preselectSiteId?: string | null;
  handleAddCompany: () => void;
  handleAddCompanySite: (companyId: string) => void;
};

export const SiteSelect: React.FC<SiteSelectPropsType> = ({
  companySites,
  preselectSiteId,
  handleAddCompany,
  handleAddCompanySite,
}) => {
  const { control } = useFormContext<CompanyLinkFormValuesType>();
  const {
    field: { name, onBlur, onChange, ref, value: siteId },
    fieldState: { error },
  } = useController({
    control,
    name: 'siteId',
  });

  const methods = useSiteCombobox({
    companySites,
    handleAddCompany,
    handleAddCompanySite,
    handleSiteIdChange: onChange,
    preselectSiteId,
    selectedSiteId: siteId,
  });

  return (
    <Grid.Col span={BUSINESS_FIELDS_GRID_COL_SPAN}>
      <SiteSelectCombobox
        {...methods}
        name={name}
        onBlur={onBlur}
        ref={ref}
        error={error}
      />
    </Grid.Col>
  );
};
